import i18n from 'utils/i18n'
import React, { useState } from "react";
import _ from 'lodash'
import { WebView as NativeWebView } from 'react-native-webview'
import Text from "theme/Text";
import { View } from 'react-native'
import HelperPlatform from 'utils/helper-platform'
import { layoutStyles } from 'styles/layout'

const WebView = ({ html, width }) => {
	
	const [ height, setHeight ] = useState( 220 )
	
	const viewStyle = HelperPlatform.select({
			web: {
			flex: 1,
			height: height,
			borderWidth: 0,
			borderColor: 'transparent'
		},
		default: {
			flex: 1,
			width: width,
			height: height,
		}
	})
	
	// Webview not working for web -> https://docs.expo.io/versions/latest/sdk/webview/
	if( HelperPlatform.isWeb() ) {
		
		// Get the height of the iframe content
		const runIframe = ( test ) => {
			const iframe = test.target;
			if( !_.isUndefined( iframe ) ) {
				const iframeWindow = iframe.contentWindow
				if( !_.isUndefined( iframeWindow ) && _.isFunction( iframeWindow.getHeight ) ) {
					setHeight( iframeWindow.getHeight() )
				}
			}
		}
		
		return (
			<View
				style={ layoutStyles.flexOne }>
				
				<iframe
					style={ viewStyle }
					onLoad={ runIframe }
					frameBorder="0"
					scrolling="no"
					srcDoc={ html }
				/>
			</View>
		)
	}
	
	const runFirst = `
		window.ReactNativeWebView.postMessage( getHeight() )
        
        true; // note: this is required, or you'll sometimes get silent failures
    `
	
	return (
		<View
			style={ layoutStyles.flexOne }>
			
			<NativeWebView
				containerStyle={ viewStyle }
				originWhitelist={ [ '*' ] }
				source={{
					html: html
				}}
				startInLoadingState={ true }
				renderError={ ( errorName ) => {
					return <Text>{errorName}</Text>;
				} }
				renderLoading={ () => {
					return <Text>{ i18n.t( 'ui.loading' ) }</Text>;
				} }
				injectedJavaScript={ runFirst }
				onMessage={(event) => {
					setHeight( parseInt( event.nativeEvent.data ) )
				}}
			/>
		</View>
	)
}

export default WebView
